import { PlaybackTokenSchema, type PlaybackToken } from "#shared/schemas/playback.ts";
import { api } from "@web/lib/api.ts";

/** Client cache — one fetch per token lifetime, not per play. */
let cached: PlaybackToken | null = null;

/**
 * Spotify access token for the Web Playback SDK + `/me/player/*` calls.
 * Refresh ~60s early so mid-song expiry doesn't stutter.
 */
export async function getPlaybackToken(force = false): Promise<string> {
  const skewMs = 60_000;
  if (
    !force &&
    cached &&
    Date.parse(cached.expires_at) - skewMs > Date.now()
  ) {
    return cached.access_token;
  }

  const body = PlaybackTokenSchema.parse(await api("/api/playback/token"));
  cached = body;
  return body.access_token;
}

export function dropPlaybackTokenCache(): void {
  cached = null;
}
